import React from "react";
import { Menu, X, Sun, Moon } from "lucide-react";

const DashboardHeader = ({
  isMobile,
  isMenuOpen,
  setIsMenuOpen,
  isDarkMode,
  themeClasses,
  activeSection,
  toggleTheme,
}) => {
  const getSectionTitle = (section) => {
    switch (section) {
      case "scan":
        return "Scan Documents";
      case "companies":
        return "Company Management";
      case "history":
        return "Document History";
      case "review":
        return "Review Queue";
      case "status":
        return "Processing Status";
      case "usage":
        return "Usage Statistics";
      case "templates":
        return "Templates";
      case "billing":
        return "Billing & Subscription";
      case "integrations":
        return "Integrations";
      default:
        return section.charAt(0).toUpperCase() + section.slice(1);
    }
  };

  return (
    <>
      {/* Mobile Header with Menu Button - Only show on mobile */}
      {isMobile && (
        <div className="flex items-center justify-between -translate-y-2">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
              isDarkMode
                ? "bg-gray-700 text-blue-500 hover:bg-gray-600"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
            }`}
          >
            {isMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
          <h1
            className={`text-xl font-bold ${themeClasses.text} font-heading`}
          >
            {getSectionTitle(activeSection)}
          </h1>
          
          {/* Theme Toggle Switch for Mobile */}
          <button
            onClick={toggleTheme}
            className={`relative inline-flex h-5 w-11 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
              isDarkMode
                ? "bg-blue-600"
                : "bg-gray-200"
            }`}
            title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          >
            <span
              className={`h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 flex items-center justify-center ${
                isDarkMode ? "translate-x-[26px]" : "translate-x-[2px]"
              }`}
            >
              {isDarkMode ? (
                <Moon className="h-3 w-3 text-blue-600" />
              ) : (
                <Sun className="h-3 w-3 text-yellow-500" />
              )}
            </span>
          </button>
        </div>
      )}

      {/* Desktop Header */}
      <div className={`${isMobile ? "hidden" : ""} flex items-center justify-between mb-5`}>
        <h1
          className={`text-4xl font-bold ${themeClasses.text} font-heading`}
        >
          {getSectionTitle(activeSection)}
        </h1>
        
        {/* Theme Toggle Switch for Desktop */}
        <button
          onClick={toggleTheme}
          className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 hover:shadow-lg ${
            isDarkMode
              ? "bg-blue-600"
              : "bg-gray-200"
          }`}
          title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          <span
            className={`h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform duration-300 flex items-center justify-center ${
              isDarkMode ? "translate-x-7" : "translate-x-1"
            }`}
          >
            {isDarkMode ? (
              <Moon className="h-4 w-4 text-blue-600" />
            ) : (
              <Sun className="h-4 w-4 text-yellow-500" />
            )}
          </span>
        </button>
      </div>
    </>
  );
};

export default DashboardHeader;
